import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type StatusVariant =
  | 'green'
  | 'amber'
  | 'red'
  | 'blue'
  | 'gray'
  | 'purple'
  | 'navy';

@Component({
  selector: 'tc-status-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.css',
})
export class StatusBadgeComponent {
  label = input.required<string>();
  variant = input<StatusVariant>('gray');
  dot = input<boolean>(false);
}
